import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators, FormGroup} from '@angular/forms';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';

import {Store} from '@ngrx/store';
import {AuthService, ConfigService, StorageService} from '@cosbeni/auth';
import {FormHelperService} from '../services/form-helper.service';
import {ToasterConfig, ToasterService} from 'angular2-toaster';

import {LotasConfig} from '../config/lotas.config';
import {DataService} from '@cosbeni/database';
import {PasswordValidators} from 'ng2-validators';

declare let jQuery: any;

/**
 * メールのリンクから開く、新しいパスワードの設定画面 (issue #170)。
 *
 * 旧 `/rest/user/change-password` は token を文字列連結で SQL に埋め込んでいたため削除され
 * (issue #169)、`/rest/public/lotas/password/reset` に置き換わった。パスワードの最低長は
 * サーバ側と同じ 8 文字。
 */
@Component({
    selector: 'app-dashboard',
    styleUrls: ['../../scss/style.scss', '../../scss/vendors/toastr/toastr.scss', 'change-password.component.css'],
    templateUrl: 'change-password.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ChangePasswordComponent implements OnInit {
    /** サーバ (PasswordResetService) と揃える */
    static readonly MIN_PASSWORD_LENGTH = 8;

    account: any = {password: ''};
    form: FormGroup;
    token: string = '';
    changed: boolean = false;
    /** リンクが無効・期限切れのときに出す案内 */
    expired: boolean = false;
    minLength: number = ChangePasswordComponent.MIN_PASSWORD_LENGTH;
    toasterconfig: ToasterConfig =
        new ToasterConfig({
            tapToDismiss: true,
            timeout: 5000,
            toastContainerId: 1
        });

    constructor(public store: Store<any>, public router: Router, public formHelper: FormHelperService, public formBuilder: FormBuilder, public auth: AuthService, public dataService: DataService, public config: ConfigService, public storage: StorageService, public toasterService: ToasterService, public route: ActivatedRoute, public http: HttpClient) {
    }

    ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                    this.token = params.token;
                }
            );
        this.form = this.formBuilder.group({
            password: new FormGroup({
                newPassword: new FormControl('', [Validators.required, Validators.minLength(ChangePasswordComponent.MIN_PASSWORD_LENGTH)]),
                confirmPassword: new FormControl('', [])
            }, PasswordValidators.mismatchedPasswords())
        });
    }

    changePassword(value: any) {
        this.expired = false;
        this.http.post(LotasConfig.SERVER_URL + '/rest/public/lotas/password/reset', {
            token: this.token,
            password: value.password.newPassword
        }).subscribe(() => {
                this.changed = true;
                this.toasterService.pop('info', '変更', 'パスワードを変更しました。新しいパスワードでログインして下さい。');
            },
            err => {
                // 400 はリンクが無効 / 期限切れ / 使用済み、それ以外はサーバ側の問題
                if (err && err.status == 400) {
                    this.expired = true;
                    this.toasterService.pop('error', '変更', 'リンクが無効か期限切れです。もう一度やり直して下さい。');
                } else {
                    this.toasterService.pop('error', '変更', 'パスワードを変更できませんでした。時間をおいてお試し下さい。');
                }
            },
        );
    }

}
